import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsLoaderService {
  private loaded = false;

  enable(): void {
    if (this.loaded || typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    const containerId = environment.idTagManager?.trim();
    if (!containerId || !/^GTM-[A-Z0-9]+$/.test(containerId)) {
      return;
    }
    if (document.getElementById('google-tag-manager')) {
      this.loaded = true;
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': Date.now(),
      event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.id = 'google-tag-manager';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(containerId)}`;
    document.head.appendChild(script);
    this.loaded = true;
  }

  disable(): void {
    this.loaded = false;
    if (typeof document === 'undefined') {
      return;
    }
    document.getElementById('google-tag-manager')?.remove();
    if (typeof window !== 'undefined') {
      window.dataLayer = [];
    }
  }

  isLoaded(): boolean {
    return this.loaded || !!document.getElementById('google-tag-manager');
  }
}
